import { render } from "./DashboardAnalytics.vue?vue&type=template&id=5dac9086"
import script from "./DashboardAnalytics.vue?vue&type=script&lang=js"
export * from "./DashboardAnalytics.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__